var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Notification50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DB8509",
    d: "M24 34.001A4 4 0 1 0 24 42.001 4 4 0 1 0 24 34.001zM26 11c0 1.104-.896 2-2 2l0 0c-1.104 0-2-.896-2-2V7c0-1.104.896-2 2-2l0 0c1.104 0 2 .896 2 2V11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC6F0A",
    d: "M27.887,38.91C27.955,38.617,28,38.314,28,38.001c0-0.383-0.07-0.746-0.172-1.097C26.609,36.965,25.333,37,24,37s-2.609-0.035-3.829-0.096C20.071,37.255,20,37.618,20,38.001c0,0.313,0.045,0.616,0.113,0.909C21.584,38.979,22.926,39,24,39S26.416,38.979,27.887,38.91z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M33,33V16.801c0-4.97-4.029-9-9-9s-9,4.03-9,9V33H33z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M41,33c0,2.209-7.059,4-17,4S7,35.209,7,33s7.059-4,17-4S41,30.791,41,33z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M7,33c0-1.999,8-9.001,8-12s18-3.001,18,0s8,9.999,8,12S7,34.999,7,33z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    d: "M9.275,29.424c-0.491,0.593-0.929,1.146-1.295,1.65c1.622,0.655,8.15,3.062,16.562,3.062c4.746,0,10.089-0.78,15.476-3.064c-0.362-0.499-0.796-1.046-1.281-1.632C25.699,34.724,12.698,30.68,9.275,29.424z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Notification50);
export default __webpack_public_path__ + "static/media/icons8-notification-50.f35bb7accc69727d8e6a7936c6994a10.svg";
export { ForwardRef as ReactComponent };